<template lang="pug">
  .jumbo
    .bg
      img(v-if="config.jumbo.img && !config.jumbo.video" :src="config.jumbo.img", alt="")
      VideoPlayer(v-if="config.jumbo.video" :video="config.jumbo.video")
    .content
      Logo.main-logo(:brand="config.front")
      | {{config.jumbo.under}}

      h4(v-if="config.undertitle") {{config.jumbo.undertitle}}
      router-link(:to="{name: 'premiacion'}")
        .play.btn-video
          span.icon-wrap
            font-awesome-icon.icon(:icon="['fa', 'play']")
          | Ver Video
</template>
<script>
import { mapState } from 'vuex'
import VideoPlayer from '@/components/VideoPlayer'
import Logo from '@/components/Logo'

export default {
  components: {
    VideoPlayer,
    Logo
  },
  computed: mapState([
    'config'
  ])
}
</script>

<style lang="scss" scoped>
  @media (max-width: 800px){
    .main-logo{
      /deep/ img{
        height: 130px;
      }
    }
  }

  .jumbo{
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    .bg{
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      overflow: hidden;
      img{
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      &:after{
        content:  '';
        position: absolute;
        height: 60vh;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(transparent, rgba(0,0,0,0.6));
      }
    }
    .content{
      position: relative;
      z-index: 2;
      text-align: center;
      padding: 1rem;

      h1{
        font-weight: 600;
        line-height: 100%;
        letter-spacing: -3px;
        font-family: 'col', sans-serif;
        text-shadow: 1px 1px 1px black;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        @include fluid-type(360px,
          1440px,
          48px,
          72px);
        color: white;
        //
        span{
          text-transform: uppercase;
          display: block;
          font-weight: 800;
          line-height: 100%;
          @include fluid-type(360px,
          1440px,
          64px,
          100px);
          margin: 0;
        }
      }
      h4{
        color: white;
        @include fluid-type(360px,
          1440px,
          16px,
          26px);
      }
    }
    height: 80vh;
  }
  .play{
    color: white;
    display: flex;
    font-family: 'Open Sans', sans-serif;
    padding: 1rem;
    font-size: 25px;
    cursor: pointer;
    text-align: center;
    position: relative;
    align-items: center;
    max-width: 220px;
    margin: 2rem auto 1rem;
    &:after{
      content: '';
      border: 2px solid white;
      position: absolute;
      left: 0;
      width: 68px;
      height: 68px;
      top: 0;
      border-radius: 50px;
      transition: all .3s;
    }
    &.back{
      margin-left: auto;
      margin-right: auto;
      font-size: 26px;
      padding: 0.9rem 0.6rem 0.9rem 0.9rem;
      max-width: 190px;
      @media (max-width: 800px){
        padding: 0.6rem 0.4rem;
        max-width: 120px;
        font-size: 16px;
        &:after{
          width: 44px;
          height: 44px;
        }
      }
    }
    .icon-wrap{
      width: 34px;
      margin-right: 24px;
      margin-left: 3px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .icon{
      padding: 0;
    }
    &:hover{
      &:after{
        width: 102%;
      }
    }
    @media screen and (max-width: 800px){
      font-size: 21px;
      line-height: 25px;
      max-width: 200px;
      .icon-wrap{
        width: 24px;
        margin-right: 24px;
        margin-left: 4px;
      }
      &:after{
        width: 58px;
        height: 58px;
      }
    }
  }
</style>
